export const getTimeZone = (): string => {
  const dateTime = new Intl.DateTimeFormat('en-US', { timeZoneName: 'long' }).format(new Date());
  return dateTime.split(', ')[1];
};
